import { Outlet } from "react-router-dom";
import { BottomTabBar } from "./BottomTabBar";

/**
 * Mobile-first authed shell. Renders the active route content above a
 * persistent bottom tab bar. Routes that want full-screen takeover
 * (e.g. Cooking Mode) should NOT mount inside this shell.
 */
export function AppShell() {
  return (
    <div className="flex h-full flex-col overflow-hidden bg-background">
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
      <BottomTabBar />
    </div>
  );
}
